import React from 'react'
import { faPersonFromPortal } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, buttonClasses, Skeleton, styled, Toolbar, Typography } from '@mui/material'

interface Props {
  userName: string
  districtName: string
  districtLoading?: boolean
  onLeaveImpersonation: () => void
}

const ImpersonationBanner: React.FC<Props> = ({
  userName,
  districtName,
  districtLoading = false,
  onLeaveImpersonation,
}) => {
  return (
    <StyledToolbar aria-live='polite' role='alertdialog'>
      <StyledTypography variant='subtitle1' component='p'>
        Impersonating “{userName || '--'}” in “{districtLoading ? <StylesSkeleton /> : districtName || '--'}”
        District
      </StyledTypography>

      <StyledButton
        color='inherit'
        size='xsmall'
        variant='text'
        startIcon={<FontAwesomeIcon icon={faPersonFromPortal} />}
        onClick={onLeaveImpersonation}
      >
        Leave Impersonation
      </StyledButton>
    </StyledToolbar>
  )
}

const StyledToolbar = styled(Toolbar)(({ theme: { palette, spacing } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: palette.indigo[600],
  color: palette.common.white,
  padding: spacing(3, 5),
  minHeight: 'auto',
}))

const StyledTypography = styled(Typography)<{ component: string }>(({ theme: { palette, spacing } }) => ({
  marginRight: spacing(2),
  color: palette.common.white,
}))

const StyledButton = styled(Button)(({ theme: { palette, spacing } }) => ({
  padding: spacing(2, 3),
  color: palette.common.white,
  backgroundColor: palette.indigo[700],

  '&:hover, &:focus': {
    backgroundColor: palette.indigo[800],
  },

  [`&.${buttonClasses.disabled}`]: {
    backgroundColor: palette.indigo[300],
  },
}))

const StylesSkeleton = styled(Skeleton)(({ theme: { palette, spacing } }) => ({
  display: 'inline-block',
  width: '70px',
}))

export default ImpersonationBanner
